import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const FADE = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" }, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } };

const APPROACH_IMG = "/family-at-table.png";

export function Approach() {
    const { t } = useTranslation();
    return (
        <section className="relative py-32 px-6 bg-white" data-testid="approach-section">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
                <motion.div {...FADE}>
                    <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#6B7DB8] font-semibold mb-6">
                        {t("approach.eyebrow")}
                    </p>
                    <h2 className="font-serif text-4xl sm:text-5xl text-[#2D2B2A] leading-tight">
                        {t("approach.headline_part1")}<br/>
                        <em className="italic text-[#4A5A95]">{t("approach.headline_emphasis")}</em>
                    </h2>
                    <div className="mt-8 space-y-5 text-[#5C5A59] text-lg leading-relaxed font-light max-w-prose">
                        <p>{t("approach.p1")}</p>
                        <p>{t("approach.p2")}</p>
                        <p className="text-[#2D2B2A] font-serif italic text-xl">{t("approach.p3_quote")}</p>
                    </div>
                </motion.div>

                <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.15 }} className="relative">
                    <div className="rounded-3xl overflow-hidden shadow-rem-card aspect-[4/3] lg:aspect-[5/4]">
                        <img
                            src={APPROACH_IMG}
                            alt="Three generations of an Australian family gathered around the kitchen table, building a remembr session together — photo albums, old letters, a posy of forget-me-nots, and the lavender tablet between them."
                            className="w-full h-full object-cover"
                            data-testid="approach-image"
                        />
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
